import { render, staticRenderFns } from "./HistroyFault.vue?vue&type=template&id=1bd7a6da&scoped=true"
import script from "./HistroyFault.vue?vue&type=script&lang=js"
export * from "./HistroyFault.vue?vue&type=script&lang=js"
import style0 from "./HistroyFault.vue?vue&type=style&index=0&id=1bd7a6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7a6da",
  null
  
)

export default component.exports